<template>
  <div>
    <m-confirm ref="confirm" mode="primary" />
    <c-loader v-if="loading" :active="true" :height="450" label="Данные загружаются" />
    <template v-else>
      <div v-if="!tabs.length" class="no-tabs">
        <div class="mb-4 text">Анкета для этой должности не настроена</div>

        <c-button color="primary" label="Настройка анкеты" @click="toProfile" />
      </div>

      <template v-else>
        <div v-if="tabs.length > 1" class="tabs">
          <button
            v-for="tab in tabs"
            :key="tab.id"
            type="button"
            class="tab"
            :class="{
              active: activeTabId === tab.id,
            }"
            @click="setTab(tab.id)"
          >
            {{ tab.name }}
          </button>
        </div>

        <profile-tab
          :user-id="userId"
          :tab="activeTab"
          :profile-data="profileData"
          :editable="editable"
          @update="updateProfileData"
          @changesCounter="hasChanges = $event"
        />
      </template>
    </template>
  </div>
</template>

<script>
import CLoader from "@/components/loader";
import CButton from "@/components/controls2/Button";

import MConfirm from "@/components/modals/confirm-modal";
import { FIELD_TYPE_FULL_NAME, FIELD_TYPE_PHOTO } from "@/domains/profile/constants/system-types";

import ProfileTab from "./components/ProfileTab";
import { ProfileData } from "../../models/ProfileData";

import { CHANGE_USER_FULL_NAME, CHANGE_USER_PHOTO } from "@/utils/events/events";
import { emit } from "@/utils/events/emitter";

export default {
  name: "profile-view",
  components: { CLoader, CButton, ProfileTab, MConfirm },

  props: ["userId", "profile", "editable"],

  data() {
    return {
      key: 1,
      loading: true,
      activeTabId: null,
      profileData: null,
      hasChanges: false,
    };
  },

  computed: {
    tabs() {
      return this.profile.tabs.filter((tab) => tab.fields.length);
    },
    activeTab() {
      const tab = this.tabs.find((tab) => tab.id === this.activeTabId);
      return tab;
    },
  },

  watch: {
    activeTabId(v) {
      const { query } = this.$route;

      if (query.tab !== v.toString()) {
        this.$router.push({
          query: {
            ...query,
            tab: v,
          },
        });
      }
    },
  },

  async created() {
    if (this.tabs.length) {
      let startTabId = this.tabs[0].id;

      const { tab } = this.$route.query;

      if (tab) {
        const hasTab = this.tabs.some((t) => t.id.toString() === tab);
        if (hasTab) startTabId = +tab;
      }

      this.activeTabId = startTabId;
    }

    await this.loadAnswers().then((response) => {
      this.profileData = ProfileData(response);
    });

    this.loading = false;
  },

  methods: {
    toProfile() {
      window.open(`/index.php?r=redesign#/profiles/${this.profile.id}`);
    },

    loadAnswers() {
      return this.$store.dispatch("personalEmployee/getUserProfileData", this.userId);
    },
    updateProfileData(values) {
      this.profileData = {
        ...this.profileData,
        ...ProfileData(values),
      };

      if (FIELD_TYPE_FULL_NAME in this.profileData) {
        const fullName = this.profileData[FIELD_TYPE_FULL_NAME];
        emit(CHANGE_USER_FULL_NAME, {
          id: this.userId,
          name: fullName.string,
        });
      }

      if (FIELD_TYPE_PHOTO in this.profileData) {
        const photo = this.profileData[FIELD_TYPE_PHOTO];
        const { files } = photo;
        emit(CHANGE_USER_PHOTO, {
          id: this.userId,
          photo: files && files.length ? files[0].url : null,
        });
      }
    },
    setTab(tabId) {
      if (this.hasChanges) {
        this.$refs.confirm.open({
          title: "Данные не сохранены",
          text: "Данные в текущей вкладке не сохранены и будут потеряны без возможности восстановления",
          confirm: "Перейти",
          onConfirm: () => {
            this.activeTabId = tabId;
          },
        });
      } else {
        this.activeTabId = tabId;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.tabs {
  margin-bottom: 20px;
  margin-left: -10px;
  margin-right: -10px;
  display: flex;
  flex-wrap: wrap;

  button {
    margin: 0 5px 10px;
    outline: none;
    background: white;
    border: 1px solid #d3d8df;
    min-height: 30px;
    display: inline-flex;
    align-items: center;
    padding: 0 20px;
    font: inherit;
    font-weight: 500;
    font-size: 12px;
    color: #8e9cbb;
    border-radius: 30px;
    cursor: pointer;
    line-height: 1;

    &.active {
      position: relative;
      color: black;

      &:before {
        content: "";
        position: absolute;
        top: -1px;
        left: -1px;
        right: -1px;
        bottom: -1px;
        border-radius: inherit;
        border: 2px solid $color-secondary;
      }
    }
  }
}

@include beforeBootstrapMd {
  .no-tabs {
    .text {
      text-align: center;
    }
    /deep/ {
      .c-button {
        width: 100%;
      }
    }
  }
}
</style>
